import { render, staticRenderFns } from "./ShipmentImportFilters.vue?vue&type=template&id=0977c7ee"
import script from "./ShipmentImportFilters.vue?vue&type=script&lang=js"
export * from "./ShipmentImportFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports